<template>

<div>
    <div v-if='rating' class="raiting">
        <span v-for='s in stars' :class="['icon icon-star-' + s]"></span>
        <span class="text">{{ rating }}</span>  
    </div>

    <div v-if='!rating'>
        <span class='badge badge-info'>Няма рейтинг</span>
    </div>
</div>

</template>

<script>
    export default {

        mounted() {
        },

        props : ['rating'],

        created() {
            if( typeof this.rating == 'undefined' || isNaN(this.rating) ) {
                console.log("Rating not provided");
                return;
            }

            this.buildStars();
        },

        data() {
            return {
                stars : []
            }
        },

        methods : {

            buildStars() {
                var r = parseFloat( this.rating );

                for( var i = 1; i < 6; i ++ ) {

                    if( i > (r+0.6) ) {

                        this.stars.push('empty');
                    
                    } else if ( i <= (r+0.35) ) {
                        
                        this.stars.push('full');
                        
                    } else {

                        this.stars.push('half');

                    }

                }

            }

        }

    }
</script>
